<div class="rating-header">
  <div class="quick-reviews">

    <div class="quick-review-btns btn-left" (click)="prevSlide()">
        <svg-selector [svgName]="'right-arrow-small'" [svgColor]="'#fff'"></svg-selector>
    </div>

    <div *ngIf="reviewsLoaded" class="quick-reviews-wrapper">
      <div class="carousel-container">
        <div class="carousel-slides" [style.transform]="'translateX(-'+currentSlide*100+'%)'">
          <div class="carousel-slide" *ngFor="let review of reviews">
            <div class="bubble">
              <p>{{ review.message }}</p>
            </div>
            <div class="reviewer">
              <div class="reviewer-country">
                <img height="10" alt="{{review.order.customer.countryCC}} Review Flag"
                     [lazyLoad]="'https://cdn.ggboost.com/images/countries/'+review.order.customer.countryCC+'.webp'">
                {{review?.order?.customer?.country}}, {{ review.createdAt }} ago.
              </div>
              <div class="reviewer-rating">
                <svg-selector [svgName]="'star-small'" [svgColor]="'#ffc107'"></svg-selector>
                <svg-selector [svgName]="'star-small'" [svgColor]="'#ffc107'"></svg-selector>
                <svg-selector [svgName]="'star-small'" [svgColor]="'#ffc107'"></svg-selector>
                <svg-selector [svgName]="'star-small'" [svgColor]="'#ffc107'"></svg-selector>
                <svg-selector [svgName]="'star-small'" [svgColor]="'#ffc107'"></svg-selector>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="quick-review-btns" (click)="nextSlide()">
      <svg-selector [svgName]="'right-arrow-small'" [svgColor]="'#fff'"></svg-selector>
    </div>

  </div>
</div>
